import * as React from "react";
import {useState} from "react";
import {useSecurity} from "./useSecurity";
import {Divider} from "@nextui-org/react";
import {AsButton, AsInput} from "../../../subframe";

export interface SecurityProps {
}

export const Security: React.FC<SecurityProps> = () => {
    const {onFormChange, allFieldsFilled, onSubmit, isLoading, formValues,isChangingPassword,setIsChangingPassword} = useSecurity();



    return (


        <div className="space-y-6">

            <div>
                <h4 className="text-base font-medium text-gray-900 mb-4">Password & Authentication</h4>
                <div className="space-y-4">

                    {isChangingPassword ? (<form

                        className="p-4 flex flex-col rounded border border-neutral-50"
                        onChange={onFormChange}
                        onSubmit={onSubmit}
                    >
                        <div className={'flex justify-between w-full'}>
                            <p className="text-body-bold font-body-bold text-neutral-900">
                                {" "}
                                Update password{" "}
                            </p>
                            <button onClick={()=>setIsChangingPassword(false)} className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 text-sm">
                                Cancel
                            </button>
                        </div>

                        <Divider className="my-4 bg-neutral-50" />
                        <div className="flex flex-col gap-10 mb-10">
                            <AsInput
                                placeholder="Enter your current password"
                                name="currentPassword"
                                textPosition="left"
                                value={formValues.currentPassword}
                                required
                            />
                            <AsInput
                                placeholder="Enter your new password"
                                name="newPassword"
                                textPosition="left"
                                value={formValues.newPassword}
                                required
                            />
                            <AsInput
                                placeholder="Confirm your new password"
                                name="confirmPassword"
                                textPosition="left"
                                value={formValues.confirmPassword}
                                required
                            />
                        </div>
                        <AsButton
                            className="w-[200px] self-end"
                            size="md"
                            variant="neutral-secondary"
                            loader={isLoading}
                            disabled={!allFieldsFilled}
                            type="submit"
                            text="Update"
                        />
                    </form>)



                    :


                    (<div className="border border-gray-200 rounded-lg p-4">
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <h5 className="text-sm font-medium text-gray-900">Change Password</h5>
                                <p className="text-sm text-gray-500 mt-1">Update your account password for enhanced
                                    security</p>
                            </div>
                            <button onClick={()=>setIsChangingPassword(true)} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm">
                                Change Password
                            </button>
                        </div>
                        <div className="text-xs text-gray-500">
                            <p>• Password must be at least 8 characters long</p>
                            <p>• Include uppercase, lowercase, numbers, and special characters</p>
                            <p>• Last changed: Never</p>
                        </div>
                    </div>) }
                </div>
            </div>
        </div>

    );
};
